function reInitSlider() {
  // @ts-ignore
  const slider = window?.recipe_slider
  if (slider) {
    slider?.updateSize()
    slider?.updateSlides()
    slider?.updateProgress()
    slider?.updateSlidesClasses()
    slider?.slideTo(0)
    slider?.scrollbar?.updateSize()
  }
}

const Tabs = () => {
  const selectors = {
    buttons: "[data-tab-index]",
  };
  
  const elements = {
    buttons: null,
  };
  
  const queryElements = () => {
    elements.buttons = document.querySelectorAll(selectors.buttons);
    registerEvents();
  };
  
  const handleButtonClick = (e) => {
    const key = e.currentTarget.dataset.tabKey;
    const index = e.currentTarget.dataset.tabIndex;
    const buttonsGroup = document.querySelectorAll(`[data-tab-key=${key}]`);
    const contentsGroup = document.querySelectorAll(
      `[data-tab-content-key=${key}]`
    );
    
    ;[...buttonsGroup].map((button) => button.classList.remove("active"));
    e.currentTarget.classList.add("active");
    
    reInitSlider();

    if (index === 'all') {
      [...contentsGroup].map((content) => (content.style.display = "block"));
      return null
    }

    [...contentsGroup].map((content) => (content.style.display = "none"));
    [...contentsGroup].reduce(
      (acc, content) => {
        const isFind = content.dataset.tabContentIndex.split(',').findIndex(i => i === index)
        
        if (isFind > -1) return [...acc, content]
        
        return acc
      }
    , []).map(block => block.style.display = "block");
  };
  
  const registerEvents = () => {
    [...elements.buttons].map((button) =>
      button.addEventListener("click", handleButtonClick)
    );
  };
  
  queryElements();
};

export default Tabs;
